<script>
  import { _ as t } from "svelte-i18n";
  import { format, parseISO } from "date-fns";
  import { it, enUS } from "date-fns/locale";
  import { Icon } from "t2c-components";

  import { getLanguage } from "../../i18n/language.js";

  export let notification;

  const now = new Date();
  $: when = (date) => {
    return format(parseISO(date), "d MMMM yyyy, HH:mm", {
      locale: $getLanguage === "it" ? it : enUS,
    });
  };

  const icon = (type) => {
    switch (type) {
      case "client created":
      case "registration completed":
      case "personal data update":
        return "person-tie";
      case "new lawcase created":
      case "lawcase modified":
      case "lawcase deleted":
        return "case";
      case "new document created":
      case "document modified":
      case "document deleted":
        return "document";
      case "new event created":
      case "event modified":
      case "event deleted":
        return "calendar";

      default:
        return "done";
    }
  };

  const color = (type) => {
    switch (type) {
      case "client created":
      case "registration completed":
      case "new lawcase created":
      case "new document created":
      case "new event created":
        return "#2a9d8f";

      case "personal data update":
      case "lawcase modified":
      case "document modified":
      case "event modified":
        return "#1a535c";

      case "lawcase deleted":
      case "document deleted":
      case "event deleted":
        return "#ff6b6b";

      default:
        return "#aaa";
    }
  };

  const extra = (type, data) => {
    const extraData = JSON.parse(data);
    if (extraData) {
      switch (type) {
        case "client created":
        case "registration completed":
        case "personal data update":
          return "";
        case "document modified":
          return extraData.new_document_title;
        case "new lawcase created":
        case "lawcase modified":
        case "lawcase deleted":
          return extraData.lawcase_title;
        case "new event created":
        case "event deleted":
          return extraData.event_title;
        case "event modified":
          return extraData.new_event_title;
        case "document deleted":
        case "new document created":
          return extraData.document_title;
        default:
          return "";
      }
    } else {
      return "";
    }
  };

  $: message = (type) => {
    const safeType = type.split(" ").join("_");
    return $t(`notification.${safeType}`);
  };
</script>

<div class="wrapper">
  <div class="icon" style={`background-color: ${color(notification.type)}`}>
    <Icon
      inline
      icon={icon(notification.type)}
      fill={icon(notification.type) === "calendar" ? "white" : "none"}
      stroke={icon(notification.type) !== "calendar" ? "white" : "none"}
    />
  </div>
  <div>
    <div class="date">{when(notification.insertedAt)}</div>
    <p class="desc">
      {message(notification.type)}
      {extra(notification.type, notification.data)}
    </p>
  </div>
</div>

<style>
  .wrapper {
    display: grid;
    grid-template-columns: 64px 1fr;
    align-items: center;
    margin: 24px 0;
  }

  @media only screen and (min-width: 600px) {
  }

  .date {
    margin-bottom: 8px;
    font-size: 14px;
    color: #999;
    padding-right: 2rem;
  }

  .desc {
    margin: 0;
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 24px;
  }
</style>
